<template>
    <div class="heading-section">
        <div class="content-wrapper">
            <div class="hs-slider-container" id="main_news">
                <h2>{{ mainNewsData.title }}</h2>
                <div v-html="mainNewsData.copy" class="hs-slider-container__content"></div>
                <!-- <a class="content__cta" target="_blank" :href="mainNewsData.url" @click.prevent="onCtaClick()">
                    {{ mainNewsData.cta }}
                </a> -->
            </div>
            <div class="hs-box hs-news">
                <news-section></news-section>
            </div>
        </div>
    </div>
</template>

<script>
import newsSlider from "@/components/sliders/news_slider";
import newsSection from "@/components/news_section";
import mainNewsJsonData from "@/generated/main_news.json";

export default {
    data() {
        return {
            mobileSliderVisible: false,
            mainNewsData: Object
        };
    },
    methods: {
        sendShortcutAnalytics: function(linkName) {
            // ga("send", "event", "na skroty", "text click", linkName);
        },
        onCtaClick: function () {
            // this.sendShortcutAnalytics();
            this.$scrollTo(this.mainNewsData.url, 300, {
                offset: -100
            });
        }
        // mobileGridChecker: function() {
        //     if (window.innerWidth < 1200) {
        //         this.mobileSliderVisible = true;
        //     } else {
        //         this.mobileSliderVisible = false;
        //     }
        // }
    },
    mounted() {
        let cmp = this;
        cmp.mainNewsData = mainNewsJsonData;
        // cmp.mobileGridChecker();

        // window.addEventListener("resize", function() {
        //     cmp.mobileGridChecker();
        // });
    },
    components: {
        newsSlider,
        newsSection
    }
};
</script>

<style lang="scss">
@import "@/scss/_general.scss";

.heading-section {
    padding-top: 20px;
    padding-bottom: 20px;

    .content-wrapper {
        display: flex;
        flex-direction: row;

        @media only screen and (max-width: 991px) {
            flex-direction: column;
        }

        .hs-box {
            .hs-box-heading {
                padding: $desktopGutter / 1.5 $desktopGutter;
                border-bottom: 2px rgba(128, 128, 128, 0.2) solid;

                h3 {
                    color: $orange1;
                    font-size: 20px;
                    // line-height: 26px;
                    font-weight: 600;
                }
            }
        }

        .hs-news {
            width: 25%;

            @media only screen and (max-width: 991px) {
                width: 100%;
                margin-left: 0px;
            }
        }

        .hs-slider-container {
            width: calc(75% - 20px);
            margin: 0 20px 0 0;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            padding: 40px 60px;
            position: relative;
            background: #fff;

            &:after {
                content: "";
                background:  url("../assets/images/virus.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: 100% 100%;
                
                position: absolute;
                top: 10%;
                right: 30px;
                width: 210px;
                height: 336px;
                
                

                @media only screen and (max-width: 1200px) {
                    opacity: .3;
                }
            }

            @media only screen and (max-width: 991px) {
                width: 100%;
                margin-bottom: 24px;
            }

            @media only screen and (max-width: 768px) {
                padding: 24px;
            }

            h2 {
                color: #FF5A00;
                font-size: 28px;
                line-height: 34px;
                font-weight: 400;
                margin-bottom: 15px;

                @media only screen and (max-width : 768px) {
                    font-size: 18px;
                    line-height: 22px;
                }
            }

            .hs-slider-container__content {
                margin-bottom: 15px;
                width: 70%;

                @media only screen and (max-width: 1200px) {
                    width: 100%;
                }

                p {
                    font-size: 18px;
                    line-height: 26px;
                    font-weight: 300;
                    margin-bottom: 12px;

                    strong {
                        font-weight: 600;
                    }

                    @media only screen and (max-width : 768px) {
                        font-size: 14px;
                        line-height: 22px;
                    }
                }
            }

            a.content__cta {
                padding: 11px 20px;
                height: 40px;
                font-size: 14px;
                color: #fff;
                line-height: 19px;
                letter-spacing: 1.6px;
                font-weight: 100;
                background: #FF5A00;
                border-radius: 2px;
                text-transform: uppercase;
                text-decoration: none;
                align-self: center;
            }
        }
    }
}
</style>
